import { put, takeLatest, call, delay, takeEvery } from "redux-saga/effects";
import adminService from "../../axios/services/adminService";
import { closeTab, createTab } from "../../utils/helpers/tabHelper";
import { authActionTypes } from "../actions/authActions";
import { adminActions, adminTypes } from "../actions/adminActions";

const initialState = {
  activeTabKey: 0,
  tabs: [],
  items: [],
  verifyAcc: false,
  tableConfig: {
    isLoading: false,
    totalData: 0,
    limit: 10,
    sort: "createdAt|desc",
    page: 1,
    filter: {
      search: ''
    }
  }
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case adminTypes.LOAD_REQUESTED: {
      return {
        ...state,
        tableConfig: {
          ...state.tableConfig,
          isLoading: true,
        }
      }
    }
    case adminTypes.LOADED: {
      return {
        ...state,
        items: action.payload.data.admins,
        tableConfig: {
          ...state.tableConfig,
          totalData: action.payload.data.count,
          isLoading: false,
        }
      };
    }
    case adminTypes.SET_TABLE_CONFIG: {
      return {
        ...state,
        tableConfig: {
          ...state.tableConfig,
          [action.key]: action.value
        }
      };
    }
    case adminTypes.SET_TABLE_CONFIG_FILTER: {
      return {
        ...state,
        tableConfig: {
          ...state.tableConfig,
          filter: {
            ...state.tableConfig.filter,
            [action.key]: action.value
          },
          page: 1
        }
      };
    }
    case adminTypes.CHANGE_TAB:
      return {
        ...state,
        activeTabKey: action.key,
      }
    case adminTypes.CLOSE_TAB: {
      const { newTabs, nextKey } = closeTab(state.tabs, action.key, state.activeTabKey);
      return {
        ...state,
        tabs: newTabs,
        activeTabKey: nextKey
      }
    }
    case adminTypes.CREATE_TAB: {
      const newTabs = createTab(state.tabs, action.key, action.title);
      return {
        ...state,
        tabs: newTabs,
        activeTabKey: action.key
      }
    }
    case adminTypes.GET_DETAIL_REQUESTED: {
      const clonedTabs = [...state.tabs];
      if (clonedTabs[action.index]) clonedTabs[action.index].loading = true;
      return {
        ...state,
        tabs: clonedTabs
      };
    }
    case adminTypes.GET_DETAIL_LOADED: {
      const clonedTabs = [...state.tabs];
      if (clonedTabs[action.index]) {
        clonedTabs[action.index].loading = false;
        clonedTabs[action.index].item = action.payload.data.admin;
      }
      return {
        ...state,
        tabs: clonedTabs
      };
    }
    case adminTypes.UPDATE_SUCCESS: {
      const newTabs = state.tabs.filter((row, key) => key !== action.index);
      return {
        ...state,
        tabs: newTabs,
        activeTabKey: 0,
      }
    }
    case adminTypes.VERIFY_ACCOUNT: {
      return {
        ...state,
        verifyAcc: true
      }
    }
    case authActionTypes.LOGOUT: {
      return initialState;
    }
    default:
      return state;
  }
};

export function* saga() {
  yield takeLatest(adminTypes.LOAD_REQUESTED, function* loadData({ tableConfig }) {
    yield delay(300);
    try {
      const search = tableConfig.filter.search ? `fullName|${tableConfig.filter.search},email|${tableConfig.filter.search},phoneNumber|${tableConfig.filter.search}` : null;
      const { data } = yield call(adminService.list, {
        page: tableConfig.page,
        limit: tableConfig.limit,
        sort: tableConfig.sort,
        search
      });
      yield put(adminActions.loaded(data));
    } catch (error) {
      // console.log('error reached', error);
    }
  });

  yield takeEvery(adminTypes.GET_DETAIL_REQUESTED, function* getDetail({ id, index }) {
    yield delay(300);
    try {
      const { data } = yield call(adminService.detail, id);
      yield put(adminActions.getDetailLoaded(data, index));
    } catch (error) {
      // console.log('error reached', error);
    }
  });
}
